import { Activity } from '../activity'

import { Template } from './template'

export default new Template({
  description: 'Generating a space report as a downloadable file',
  id: Template.Id.SpaceReportGenerate,
  name: 'Space Report Generation',
  steps: [
    {
      withoutItems: {
        description: 'Fetching the data the report needs from the DMS',
        name: 'Gathering report data',
        type: Activity.Type.GeneratingFileContent,
      },
    },
    {
      withoutItems: {
        description: 'Rendering the report into a downloadable file',
        name: 'Rendering the file',
        type: Activity.Type.RenderingFile,
      },
    },
    {
      withoutItems: {
        description: 'Storing the file so it can be downloaded',
        name: 'Storing the file',
        type: Activity.Type.StoringFile,
      },
    },
  ],
})
